const tabReducer = (state = 0, action) => {
  switch (action.type) {
    case "storeLandingTab":
      return action.payload;
    default:
      return state;
  }
};

export default tabReducer;
